<template>
  <v-card
    max-width="1000"
    class="rounded-0 mx-auto"
    :disabled="loading"
    :loading="loading"
    ><v-toolbar id="section-9" color="black">
      <v-toolbar-title
        ><h1>{{ $t("info_card.title_page9") }}</h1>
      </v-toolbar-title>
    </v-toolbar>
    <v-card-text class="pa-0 pa-sm-3 pa-xl-6">
      <v-expansion-panels v-model="panel" class="mx-auto">
        <v-expansion-panel
          v-for="(item, index) in computedDocumentData"
          :key="index"
          @click="onExpansionPanelClick(index, item.DOCUMENT_TYPE_ID)"
        >
          <v-expansion-panel-title>
            <h5>
              {{ index + 1 }}.
              {{ objectTranslator(item, "DOCUMENT_TYPE_NAME") }}
            </h5>
          </v-expansion-panel-title>
          <v-expansion-panel-text class="pa-1 pa-sm-3">
            <v-row>
              <v-col
                cols="12"
                v-for="(item, index) in currentFiles"
                :key="index"
              >
                <v-card variant="outlined" elevation="0" class="pa-3">
                  <p>
                    {{ $t("upload.file") }}: {{ index + 1 }}/{{
                      currentFiles.length
                    }}
                  </p>

                  <a
                    :href="item.src"
                    target="_blank"
                    v-if="item.type == 'application/pdf'"
                  >
                    <v-btn
                      class="mb-1 float-right"
                      color="error"
                      variant="outlined"
                      prepend-icon="mdi-file-pdf-box"
                      elevation="0"
                    >
                      {{ $t("upload.view_file") }}
                    </v-btn>
                  </a>

                  <embed
                    :src="item.src"
                    width="100%"
                    height="500px"
                    type="application/pdf"
                    v-if="item.type == 'application/pdf'"
                  />

                  <PrimeVueImage :src="item.src" v-else />
                </v-card>
              </v-col>
              <v-col
                v-if="
                  currentFiles.length === 0 && !loading && currentDocumentTypeId
                "
              >
                <p class="text-center text-secondary">no file uploaded</p>
              </v-col>
            </v-row>
          </v-expansion-panel-text>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-card-text></v-card
  >
</template>

<script>
import PrimeVueImage from "@/components/info_cards/PrimeVueImage.vue";
import UploadProvider from "@/services/upload.provider";
import { objectTranslator } from "@/helper/translator";

const uploadProvider = new UploadProvider();

export default {
  name: "SectionThree",

  components: {
    PrimeVueImage,
  },

  data: () => ({
    loading: false,
    panel: null,

    documentTypeData: [],
    documentData: [],

    currentDocumentTypeId: null,
    currentPageCount: null,
    currentFiles: [],
  }),

  computed: {
    uid() {
      return this.$store.state.user.surrogated_student_uid;
    },

    student_id() {
      return this.$store.state.user.surrogated_student_id;
    },

    surrogated_student_info() {
      return this.$store.state.user.surrogated_student_info;
    },

    uploadStatuss() {
      return this.$store.state.ref.uploadStatuss;
    },

    isLockedUpload() {
      return (
        this.surrogated_student_info &&
        this.surrogated_student_info.LOCK_UPLOAD === "1"
      );
    },

    computedDocumentData() {
      return this.documentTypeData.map((item) => {
        let setted = false;

        this.documentData.map((item2) => {
          if (item.DOCUMENT_TYPE_ID === item2.DOCUMENT_TYPE_ID) {
            setted = true;
            item.UPLOAD_STATUS_ID = item2.UPLOAD_STATUS_ID;
            item.COMMENT = item2.COMMENT;
          }
        });

        if (setted === false) {
          item.UPLOAD_STATUS_ID = "1";
          item.COMMENT = "";
        }

        this.uploadStatuss.map((item2) => {
          if (item.UPLOAD_STATUS_ID === item2.UPLOAD_STATUS_ID) {
            item.UPLOAD_STATUS_NAME_TH = item2.UPLOAD_STATUS_NAME_TH;
            item.UPLOAD_STATUS_NAME_EN = item2.UPLOAD_STATUS_NAME_EN;
          }
        });

        return item;
      });
    },
  },

  methods: {
    objectTranslator,

    getUploadStatusChipColor(UPLOAD_STATUS_ID) {
      let color = "";
      switch (UPLOAD_STATUS_ID) {
        case "1":
          color = "black";
          break;
        case "2":
          color = "warning";
          break;
        case "3":
          color = "success";
          break;
        case "4":
          color = "error";
          break;
      }
      return color;
    },

    getUploadStatusChipIcon(UPLOAD_STATUS_ID) {
      let icon = "";
      switch (UPLOAD_STATUS_ID) {
        case "1":
          icon = null;
          break;
        case "2":
          icon = "mdi-clock-outline";
          break;
        case "3":
          icon = "mdi-check-circle-outline";
          break;
        case "4":
          icon = "mdi-close-circle";
          break;
      }
      return icon;
    },

    async fetchData() {
      this.loading = true;

      let data = await uploadProvider
        .getDocumentType({ level_id: this.surrogated_student_info.LEVEL_ID })
        .catch((error) => {
          this.$toast.error(JSON.stringify(error.response.data.message));
          this.loading = false;
        });
      if (data) {
        if (this.surrogated_student_info.FACULTY_ID == '95') {
          this.documentTypeData = data.filter(item => item.DOCUMENT_TYPE_ID >= 951);
        } else {
          this.documentTypeData = data.filter(item => item.DOCUMENT_TYPE_ID < 951);
        }
      }

      data = await uploadProvider
        .getDocument({ uid: this.uid, student_id: this.student_id })
        .catch((error) => {
          this.$toast.error(JSON.stringify(error.response.data.message));
          this.loading = false;
        });
      if (data) this.documentData = data;

      this.loading = false;
    },

    onExpansionPanelClick(index, DOCUMENT_TYPE_ID) {
      if (this.panel != index) {
        this.clear();
        return;
      }

      if (this.currentDocumentTypeId === null) {
        this.currentDocumentTypeId = DOCUMENT_TYPE_ID;
        this.getFiles();
        return;
      }

      if (this.currentDocumentTypeId !== DOCUMENT_TYPE_ID) {
        this.clear();
        this.currentDocumentTypeId = DOCUMENT_TYPE_ID;
        this.getFiles();
        return;
      }
    },

    clear() {
      this.currentDocumentTypeId = null;
      this.currentPageCount = null;
      this.currentFiles.forEach((item) => {
        window.URL.revokeObjectURL(item);
      });
      this.currentFiles = [];
    },

    async getFiles() {
      this.loading = true;

      const data = await uploadProvider
        .getDocumentPages({
          uid: this.uid,
          student_id: this.student_id,
          DOCUMENT_TYPE_ID: this.currentDocumentTypeId,
        })
        .catch((error) => {
          this.$toast.error(JSON.stringify(error.response.data.message));
          this.loading = false;
        });

      if (data && data.number) {
        this.currentPageCount = data.number;

        for (let i = 1; i <= this.currentPageCount; i++) {
          const data = await uploadProvider
            .getDocumentFile({
              uid: this.uid,
              student_id: this.student_id,
              DOCUMENT_TYPE_ID: this.currentDocumentTypeId,
              PAGE: i,
            })
            .catch((error) => {
              error.response.data.text().then((text) => {
                this.$toast.error(text);
              });
              this.loading = false;
            });
          if (data) {
            this.currentFiles.push({
              src: window.URL.createObjectURL(data),
              type: data.type,
            });
          }
        }
      }

      this.loading = false;
    },
  },

  created() {
    this.$store.dispatch("ref/getUploadStatuss");
    this.fetchData();
  },
};
</script>
<style scoped>
.v-expansion-panel-title {
  display: block !important;
}

.v-expansion-panel-title__icon {
  float: right;
}

.v-expansion-panel-text__wrapper {
  padding: 0px !important;
}

.v-chip {
  margin: 2px;
}
</style>
